export default __webpack_public_path__ + "static/media/closeButtonBanner.c7c0901f.svg";